import { render, staticRenderFns } from "./course-section-edit.html?vue&type=template&id=6b4e7840&scoped=true&"
import script from "./course-section-edit.js?vue&type=script&lang=js&"
export * from "./course-section-edit.js?vue&type=script&lang=js&"
import style0 from "./course-section-edit.css?vue&type=style&index=0&id=6b4e7840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e7840",
  null
  
)

export default component.exports